// @ts-nocheck
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackPageViewParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackPageView";
import { RecursivePartial } from "@toolkit/Framework/Types/Common";

/* Store Custom Code - Start */
import * as storeHooks from "@store/Framework/GoogleAnalytics/hooks";
/* Store Custom Code - End */

const baseGA = { ...ga };

Object.assign<Toolkit.GoogleAnalytics, RecursivePartial<Toolkit.GoogleAnalytics>>(ga, {
    /* Store Custom Code - Start */
    use: {
        ...ga.use,
        ...storeHooks,
    },
    /* Store Custom Code - End */
});
